/* eslint-disable indent */
/* eslint-disable class-methods-use-this */
// eslint-disable-next-line no-sparse-arrays
import React, { Component } from 'react';
import PopupClose from '~/components/popups/Close';
import blockLibrary from '../data/blockLibrary';
import Input from '~/components/forms/Input';
import Select from '~f/Select';
import VideoInput from '~/components/forms/VideoInput';
import Image from '~/components/forms/Image';
import File from '~/components/forms/File';
import Icon from '~/components/forms/Icon';
import AddButton from '~/components/forms/AddButton';
import EventDate from '~/components/forms/EventDate';
import AnchorNav from '~/components/forms/AnchorNav';
import InputHTML from '~/components/forms/InputHTML';
import TableHTML from '~/components/forms/TableHTML';
import Checkboxes from '~/components/forms/Checkboxes';
import AnchorSettings from '../AnchorSettings';

export default class BlockFormPopup extends Component {
  constructor(props) {
    super(props);
    let block;
    if (props.edit) {
      block = props.block;
    } else {
      block = JSON.parse(
        JSON.stringify(blockLibrary.filter(b => b.type == props.block).pop()),
      );
    }
    block.sort = props.sort;

    this.state = {
      block: block,
    };
  }

  changeInputValue(value, link) {
    const { block } = this.state;
    const newBlock = Object.assign({}, block);
    newBlock.content[link[0]][link[1]][link[2]] = value;
    this.setState({ block: newBlock });
  }

  // TODO: Refactor, extend to module-function
  prepareInput(input, value, link) {
    const { disciplines } = this.props;
    switch (input.type) {
      case 'select':
        return (
          <Select
            label={input.label}
            value={value}
            options={input.options}
            onChange={val => this.changeInputValue(val, link)}
          />
        );

      case 'text':
        return (
          <Input
            label={input.label}
            value={value}
            onChange={val => this.changeInputValue(val, link)}
          />
        );

      case 'html':
        return (
          <InputHTML
            value={value}
            onChange={val => this.changeInputValue(val, link)}
          />
        );

      case 'table_html':
        return (
          <TableHTML
            value={value}
            onChange={val => this.changeInputValue(val, link)}
          />
        );

      case 'video':
        return (
          <VideoInput
            label={input.label}
            value={value}
          />
        );

      case 'image':
        return (
          <Image
            label={input.label}
            value={value}
            onChange={value => this.changeInputValue(value, link)}
          />
        );

      case 'file':
        return (
          <File
            label={input.label}
            value={value}
            onChange={value => this.changeInputValue(value, link)}
          />
        );

      case 'icon':
        return (
          <Icon
            label={input.label}
            value={value}
            onChange={val => this.changeInputValue(val, link)}
          />
        );
      case 'button':
        return (
          <AddButton
            label={input.label}
            value={value}
          />
        );
      case 'date':
        return (
          <EventDate
            label={input.label}
            value={value}
          />
        );
      case 'anchor':
        return (
          <AnchorNav
            label={input.label}
            value={value}
          />
        );
      case 'cta_reference':
        return (
          <Checkboxes
            label={input.label}
            value={value}
            options={disciplines.all}
            onChange={e => this.changeInputValue(value, link)}
          />
        );

      case 'cta_reference_free':
        return (
          <Checkboxes
            label={input.label}
            value={value}
            options={disciplines.free}
            onChange={e => this.changeInputValue(value, link)}
          />
        );

      default:
        return (
          <p className="txt txt--red">Неизвестный формат поля: {input.type}</p>
        );
    }
  }

  prepareForm(block) {
    const parent = this;
    const noNeedToParse = ['aside', 'anchor'];
    const groups = Object.keys(block.content)
      .filter(key => noNeedToParse.indexOf(key) == -1)
      .map(group => {
        const currentGroup = block.forms.filter(g => g.name == group).pop();

        const groupItems = block.content[group].map(
          (itemGroup, itemGroupIndex) => {
            const inputs = currentGroup.items.map((currentInput) => {
              const inputName = Object.keys(itemGroup)
                .filter(i => i != 'children' && i == currentInput.name);

                const inputClasses = ['form-group__input'];
                inputClasses.push(`form-group__input--${currentInput?.size}`);

                return (
                  <div
                    key={`${group}-${itemGroupIndex}-${inputName}`}
                    className={inputClasses.join(' ')}
                  >
                    {parent.prepareInput(currentInput, itemGroup[inputName], [
                      group,
                      itemGroupIndex,
                      inputName,
                    ])}
                  </div>
                );
              });

            const delBtn = (
              <button
                className="form-group__del"
                title="Удалить группу"
                onClick={() => this.removeGroupItem(group, itemGroupIndex)}
              />
            );
            const canDelete =
              currentGroup.multiple &&
              currentGroup.multiple.min < block.content[group].length;

            const groupHeader = (
              <p className="title">
                {currentGroup.label.replace(/{i}/g, itemGroupIndex + 1)}
                {canDelete && delBtn}
              </p>
            );

            return (
              <div
                key={`${group}-${itemGroupIndex}`}
                className={`form-group__item form-group__item--${currentGroup.size}`}
              >
                {groupHeader}
                {inputs}
              </div>
            );
          },
        );

        const canAdd =
          currentGroup.multiple &&
          currentGroup.multiple.max > block.content[group].length;
        const addBtn = (
          <button
            className="btn btn--action-outline"
            onClick={() => this.addGroupItem(group)}
          >
            + Добавить
          </button>
        );

        return (
          <div key={group} className="form-group">
            <div className="form-group__items">{groupItems}</div>
            {canAdd && addBtn}
          </div>
        );
      });

    return groups;
  }

  addGroupItem(group) {
    // Add element, copy of content from first
    const newBlock = JSON.parse(JSON.stringify(this.state.block));
    const newItem = JSON.parse(JSON.stringify(newBlock.content[group][0]));
    if (newItem.children) newItem.children = [];
    newBlock.content[group].push(newItem);

    this.setState({ block: newBlock });
  }

  removeGroupItem(group, index) {
    // Remove element, copy of content from first
    const newBlock = JSON.parse(JSON.stringify(this.state.block));
    newBlock.content[group].splice(index, 1);

    this.setState({ block: newBlock });
  }

  updateAnchorSettings(status, navtext) {
    const { block } = this.state;
    const newBlock = JSON.parse(JSON.stringify(block));
    newBlock.content.anchor = {
      status: status,
      text: navtext,
    };
    this.setState({ block: newBlock });
  }

  render() {
    const { block } = this.state;
    const { onSave } = this.props;
    return (
      <div className="popup-tilda">
        <div className="popup__close-container close_block_form"><PopupClose/></div>
        <div className="form-actions">
          <button
            className="btn btn--action"
            onClick={() => $.magnificPopup.close()}
          >
            Отменить
          </button>
          <button
            className="btn btn--action-outline"
            onClick={() => onSave(block)}
          >
            Сохранить и закрыть
          </button>
        </div>
        <h4 className="heading heading--2">
          Редактирование блока «{block.label}»
        </h4>

        <AnchorSettings
          block={block}
          onChange={(status, navtext) =>
            this.updateAnchorSettings(status, navtext)
          }
        />

        <div className="form-content">{this.prepareForm(block)}</div>
      </div>
    );
  }
}
